import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

let i18nInstance = null;

export function setI18nInstance(i18n) {
  i18nInstance = i18n;
}

export const useLocaleStore = defineStore('locale', () => {
  const currentLocale = ref('fr');

  const isEnglish = computed(() => currentLocale.value === 'en');
  const isFrench = computed(() => currentLocale.value === 'fr');

  function setLocale(locale) {
    if (locale !== 'fr' && locale !== 'en') {
      console.warn(`Invalid locale: ${locale}, defaulting to 'fr'`);
      locale = 'fr';
    }
    currentLocale.value = locale;
    localStorage.setItem('locale', locale);
    document.documentElement.lang = locale;

    // Synchroniser i18n immédiatement
    if (i18nInstance) {
      i18nInstance.global.locale.value = locale;
    }
  }

  function detectUserLocale() {
    const browserLang = navigator.language.toLowerCase();
    return browserLang.startsWith('en') ? 'en' : 'fr';
  }

  function initLocale(urlLocale = null) {
    let locale = 'fr';

    if (urlLocale && (urlLocale === 'en' || urlLocale === 'fr')) {
      locale = urlLocale;
    } else {
      const storedLocale = localStorage.getItem('locale');
      if (storedLocale === 'en' || storedLocale === 'fr') {
        locale = storedLocale;
      } else {
        locale = detectUserLocale();
      }
    }

    setLocale(locale);
  }

  return {
    currentLocale,
    isEnglish,
    isFrench,
    setLocale,
    detectUserLocale,
    initLocale,
  };
});
